<template>
    <div :class="{ 'next-background': mode === 'home' }">
        <mainindex>
            <div v-if="!islogmode" class="content">
                <!--<div class="content" v-if="gen._UID && !islogmode">-->
                <!--HEADER-->
                <page-header v-if="mode !== 'home'" :cur-page="mode" :dark-mode="true" :menu-tree="menu" @nav="go($event)" @openlogspanel="toggleLogsPanel" @clone-prj="cloneProject" @save-prj="savePrj()" @new-prj="newPrj"></page-header>
                <!--HEADER-->

                <!--BODY-->
                <div :class="[paddingClass]" class="body">
                    <template v-if="mode === 'home'">
                        <home @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
                    </template>
                    <template v-else-if="mode === 'startprj'">
                        <start-prj @nav="go($event)"></start-prj>
                    </template>
                    <template v-else-if="mode === 'projects.guest' && user.guest">
                        <prj-finder
                            key="CUSTOMER"
                            :cols="[
                                { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                { id: 'id', title: 'id', order: 0 },
                                { id: 'des', title: 'name', order: 6 },
                                { id: 'shop', title: 'shop', order: 8 },
                                { id: 'status', title: 'status', order: 4 },
                                { id: 'lastedit', title: 'last edit', order: 11 }
                            ]"
                            :rows-number="5"
                            filter="GUEST"
                            order-by="11D"
                            title="My Projects"
                            @open="openPrj($event)"
                        ></prj-finder>
                    </template>
                    <template v-else-if="mode === 'projects.my'">
                        <prj-finder
                            key="MY"
                            :cols="[
                                { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                { id: 'id', title: 'id', order: 0 },
                                { id: 'des', title: 'name', order: 6 },
                                { id: 'shop', title: 'shop', order: 8 },
                                { id: 'status', title: 'status', order: 4 },
                                { id: 'lastedit', title: 'last edit', order: 11 }
                            ]"
                            :rows-number="5"
                            filter="MY"
                            order-by="11D"
                            title="My Projects"
                            @open="openPrj($event)"
                        ></prj-finder>
                    </template>
                    <template v-else-if="mode === 'projects.ext' && !user.guest">
                        <prj-finder
                            key="OTHERPRJ"
                            :cols="[
                                { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                { id: 'id', title: 'id', order: 0 },
                                { id: 'des', title: 'name', order: 6 },
                                { id: 'shop', title: 'shop', order: 8 },
                                { id: 'status', title: 'status', order: 4 },
                                { id: 'lastedit', title: 'last edit', order: 11 },
                                { id: 'assign', title: null }
                            ]"
                            :rows-number="5"
                            filter="OTHERPRJ"
                            order-by="11D"
                            title="Other Projects In My Store"
                            @open="openPrj($event)"
                        ></prj-finder>
                    </template>
                    <template v-else-if="mode === 'projects.clinv' && !user.guest">
                        <prj-finder
                            key="CLOSED"
                            :cols="[
                                { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                { id: 'id', title: 'id', order: 0 },
                                { id: 'des', title: 'name', order: 6 },
                                { id: 'shop', title: 'shop', order: 8 },
                                { id: 'status', title: 'status', order: 4 },
                                { id: 'lastedit', title: 'last edit', order: 11 },
                                { id: 'assign', title: null }
                            ]"
                            :rows-number="5"
                            filter="CLOSED"
                            order-by="11D"
                            title="Closed Projects"
                            @open="openPrj($event)"
                        ></prj-finder>
                        <prj-finder
                            key="INACTIVE"
                            :cols="[
                                { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                { id: 'id', title: 'id', order: 0 },
                                { id: 'des', title: 'name', order: 6 },
                                { id: 'shop', title: 'shop', order: 8 },
                                { id: 'status', title: 'status', order: 4 },
                                { id: 'lastedit', title: 'last edit', order: 11 },
                                { id: 'assign', title: null }
                            ]"
                            :rows-number="5"
                            filter="INACTIVE"
                            order-by="11D"
                            title="Inactive Projects"
                            @open="openPrj($event)"
                        ></prj-finder>
                    </template>
                    <template v-else-if="mode === 'notifications'">
                        <notifications></notifications>
                    </template>
                    <template v-else-if="mode === 'itemsearch'">
                        <article-search @nav="go($event)"></article-search>
                    </template>
                    <template v-else-if="mode === 'renders'">
                        <renders @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'configurator'">
                        <configure @nav="go($event)"></configure>
                    </template>
                    <template v-else-if="mode === '3dview' || mode === 'planner'">
                        <view3d :load-header-on-start="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === '2dview'">
                        <view2d :load-header-on-start="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'compositions'">
                        <compositions :apply-header="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'offerview'">
                        <offer></offer>
                    </template>
                    <template v-else-if="mode === 'summary'">
                        <prj-summary />
                    </template>
                    <template v-else-if="mode === 'customerinfo'">
                        <customer-info />
                    </template>
                    <template v-else-if="mode === 'prjlog'">
                        <prj-log />
                    </template>
                    <template v-else-if="mode === 'delivery'">
                        <delivery />
                    </template>
                    <template v-else-if="mode === 'promotions'">
                        <promotions />
                    </template>
                    <template v-else-if="mode === 'json'">
                        <d-json :value="prj" />
                    </template>
                    <template v-else-if="mode === 'myprofile'">
                        <my-profile />
                    </template>
                    <template v-else-if="mode === 'utilities'">
                        <utilities />
                    </template>
                    <template v-else>
                        <h1>::::{{ mode }}::::</h1>
                    </template>
                </div>
                <!--BODY-->
            </div>
            <home v-else @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
        </mainindex>

        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
    </div>
</template>

<script>
    import "../../../scss/giorgetti.scss";
    import index from "@configurator/index";

    import Utilities from "@custom/pages/utilities";
    import { NextApiClient } from "@3cad/nextcore";

    export default {
        mixins: [index],
        components: {
            Utilities
        },
        data() {
            return {
                menu: require("@assets/next/json/menu.json")
            };
        },
        computed: {
            paddingClass() {
                switch (this.mode) {
                    case "home":
                        return "no-menu";
                    case "startprj":
                    case "projects":
                    case "projects.my":
                    case "projects.ext":
                    case "projects.clinv":
                        return "mid-menu";
                    default:
                        return "full-menu";
                }
            }
        },
        methods: {
            resetCustomerParams() {
                let customerFields = {
                    catalogPath: null
                };
                this.$set(this.prj, "customerFields", customerFields);
            },
            onProjectLoaded() {
                this.resetFiltraVariantiGraficheFiltersSaved();
                if ("catalogPath" in this.prj.customerFields) {
                    // do nothing
                } else {
                    let catalogPath = `${NextApiClient.backSite}/data/${this.prj.history[this.prj.history.length - 1].catalog}`;
                    this.$set(this.prj, "customerFields", { catalogPath });
                }
                this.go("offerview");
            }
        }
    };
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/custom/giorgetti/start.vue